module.exports = __webpack_public_path__ + "img/trainer-snip2.184c1285.jpg";